import RestApiModel from "@/api/Model/RestApiModel";
import ReportType from '@/api/Company/ReportType';
import api from '@/api';

class DistributionList extends RestApiModel {
  static types = ReportType;
  static list(facilityId) {
    return super.list({
      endpoint: `/companies/${facilityId}/distribution-lists`
    })
  }

  static getResourceEndpoint() {
    return `/company-distribution-lists`;
  }

  static recipients(distributionListId) {
    return super.list({
      endpoint: `${this.getResourceIdEndpoint(distributionListId, 'recipients')}`
    })
  }

  /**
   *
   * @param distributionListId
   * @param recipientIds
   * @returns {*}
   */
  static removeRecipients(distributionListId, recipientIds)
  {
    return api.delete(this.getResourceIdEndpoint(distributionListId, `recipients/remove`), {data: {recipientIds}});
  }
}

export default DistributionList;
